import React, { useState, useEffect } from 'react';
import { CheckIcon } from '../../../Constants/Icons';
const Timeline = ({ currentStep }) => {

    const [progressWidth, setProgressWidth] = useState(0);

    useEffect(() => {
        if (currentStep === 0) {
            setProgressWidth("8rem");
        } else if (currentStep === 1) {
            setProgressWidth("50%");
        } else if (currentStep === 2) {
            setProgressWidth("calc(100% - 9rem)");
        } else if (currentStep === 3) {
            setProgressWidth("100%");
        }
    }, [currentStep]);

    return (
        <div className="w-full pb-4">
            <div className="relative w-full">
                <div className="absolute top w-full h-[2px] bg-usersLink" style={{ width: progressWidth, zIndex: 1 }}></div>
                <div className="absolute top w-full h-[2px] bg-neutral-medium"></div>

                <div className="absolute -top-4 left-0 w-full flex flex-row justify-between px-32">
                    <div className="flex flex-col items-center" style={{ zIndex: 2 }}>
                        <div className={`w-[32px] h-[32px] rounded-full border border-2 border-usersLink flex items-center justify-center ${currentStep > 0 ? 'bg-usersLink' : 'bg-white'}`}>
                            {currentStep > 0 ? <CheckIcon /> : null}
                        </div>
                        <h3 className="absolute mt-10 text-center text-usersLink font-allroundgothic text-lg md:text-xl 2xl:text-2xl">
                            <span>Vendor</span><br /><span>Details</span>
                        </h3>
                    </div>
                    <div className="flex flex-col items-center" style={{ zIndex: 2 }}>
                        <div className={`w-[32px] h-[32px] rounded-full border border-2 border-usersLink flex items-center justify-center ${currentStep > 1 ? 'bg-usersLink' : 'bg-white'}`}>
                            {currentStep > 1 ? <CheckIcon /> : null}

                        </div>
                        <h3 className="absolute mt-10 text-center text-usersLink font-allroundgothic text-lg md:text-xl 2xl:text-2xl">
                            <span>Product</span><br /><span>Details</span>
                        </h3>
                    </div>
                    <div className="flex flex-col items-center" style={{ zIndex: 2 }}>
                        <div className={`w-[32px] h-[32px] rounded-full border border-2 border-usersLink flex items-center justify-center ${currentStep > 2 ? 'bg-usersLink' : 'bg-white'}`}>
                            {currentStep > 2 ? <CheckIcon /> : null}
                        </div>
                        <h3 className="absolute mt-10 text-center text-usersLink font-allroundgothic text-lg md:text-xl 2xl:text-2xl">
                            <span>Account</span><br /><span>Info</span>
                        </h3>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Timeline;